import type { WikiLang } from '../services/generated/Api';
import { X_DEFAULT_LANGUAGE } from './locale';

// WHY: модуль тянет proxy — значения перечисления из сгенерированного клиента на 20 тысяч строк сюда не импортируем,
// совпадение списка с WikiLang держит тест
const WIKI_LANG_CODES: readonly string[] = ['en', 'ru', 'uz', 'tr', 'pt', 'fa', 'uk', 'de', 'es', 'pl'] satisfies readonly `${WikiLang}`[];

const isWikiLang = (value: string | null | undefined): value is WikiLang => WIKI_LANG_CODES.some((code) => code === value);

export const WIKI_LANGS: WikiLang[] = WIKI_LANG_CODES.filter(isWikiLang);

export const toWikiLang = (value: string | null | undefined): WikiLang | null => (isWikiLang(value) ? value : null);

const WIKI_FALLBACK_LANG: WikiLang = WIKI_LANGS.find((lang) => lang === X_DEFAULT_LANGUAGE) ?? WIKI_LANGS[0];

export const wikiContentLang = (language: string | null | undefined): WikiLang => toWikiLang(language) ?? WIKI_FALLBACK_LANG;

export const hasOwnWiki = (language: string | null | undefined): boolean => isWikiLang(language);
